<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.supervisor"
        ref="RkmDataTable"
        sort-by="usuario"
    >

        <template v-slot:cell(actions)="{ item }">
            <template>
                <rkm-button
                    @click.stop="$router.push({ name: 'transporte-paciente-supervisor-edit', params: { id: item.id } })"
                    color="primary"
                    small
                    title="Editar"
                    autorize="edit-transporte-paciente-supervisor"
                >
                    <rkm-icon icon="pen"/>
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                    autorize="destroy-transporte-paciente-supervisor"
                >
                    <rkm-icon icon="trash"/>
                </rkm-button>
            </template>
        </template>
    </rkm-data-table>
</template>

<script>

// Mixins.
import { error, repository, stringCase} from '@/mixins';

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'usuario',
                    label: 'Profissional',
                    name: 'cadastroCidadao.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'unidade',
                    label: 'Unidade',
                    name: 'cadastroUnidade.nomeFantasia',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'infraestrutura',
                    label: 'Local de atendimento',
                    name: 'cadastroInfraestrutura.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                },
            ];
        }
    },
    created() {
        this.repositories = {
            supervisor: this.getConectaSusRepository('transportePaciente.supervisor')
        }
    },
    methods: {
        handleDestroy(item) {

            const exclusao = () => this.repositories.supervisor.destroy(item.id)
            .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation(
                'Deseja realmente excluir o supervisor?',
                exclusao,
                this.handleError
            )
        },
    },
    mixins: [ error, repository, stringCase ],
};

</script>